const { __ } = wp.i18n;
const { Flex, FlexItem, FlexBlock, TextControl, Button, PanelBody, PanelRow } = wp.components;
const { useState, useRef } = wp.element;

import React from "react";
import BControlPro from "../../../../components/BControlPro";
import PremiumText from "../../PremiumText";

const Markers = ({ attributes, panelRef, handleOptions, isPremium }) => {
  const {
    options: { markers },
  } = attributes;

  const [pointsDraft, setPointsDraft] = useState({});

  const handleChapter = (point, index) => {
    const pointsCopy = [...markers.points];
    pointsCopy[index] = point;
    handleOptions({ points: pointsCopy }, "markers");
  };

  // console.log(markers);

  const handleAdd = () => {
    console.log(pointsDraft);
    if (pointsDraft.time && pointsDraft.label) {
      const pointsCopy = [...markers.points];
      pointsCopy.push(pointsDraft);
      handleOptions({ points: pointsCopy }, "markers");
      setPointsDraft({});
    }
  };

  const handleRemove = (itemIndex) => {
    const pointsCopy = [...markers.points];
    handleOptions({ points: pointsCopy.filter((item, index) => index !== itemIndex) }, "markers");
  };

  const handleMarkers = () => {
    // handleOptions();
  };

  return (
    <PanelBody ref={panelRef} title={__("Chapters", "h5vp")} initialOpen={false}>
      <PremiumText isPremium={isPremium} />
      {isPremium && (
        <>
          {markers.points.map((chapter, index) => (
            <BControlPro
              isPremium={isPremium}
              Component={Chapter}
              Chapter
              key={index}
              onRemove={() => handleRemove(index)}
              chapter={chapter}
              onChange={(newChapter) => handleChapter(newChapter, index)}
            />
          ))}
          <Chapter addNew={true} onAdd={handleAdd} chapter={pointsDraft} onChange={(newChapter) => setPointsDraft(newChapter)} />
        </>
      )}
    </PanelBody>
  );
};

export default Markers;

export const Chapter = ({ chapter, key, onChange, onAdd, addNew = false, onRemove }) => {
  const { time = "", label = "" } = chapter;
  const minusWrapper = useRef(null);

  return (
    <Flex>
      <FlexItem>
        <TextControl style={{ width: "55px" }} value={time} placeholder="00:00" onChange={(val) => onChange({ ...chapter, time: val })} />
      </FlexItem>
      <FlexItem>
        <TextControl style={{ marginLeft: "10px" }} value={label} placeholder="Label" onChange={(val) => onChange({ ...chapter, label: val })} />
      </FlexItem>
      <FlexItem>
        {addNew ? (
          <Button icon="plus-alt" style={{ marginBottom: "10px" }} onClick={onAdd} />
        ) : (
          <div
            ref={minusWrapper}
            style={{ opacity: "0" }}
            onMouseEnter={() => (minusWrapper.current.style.opacity = 1)}
            onMouseLeave={() => (minusWrapper.current.style.opacity = 0)}
          >
            <Button icon="minus" style={{ marginBottom: "10px" }} onClick={onRemove} />
          </div>
        )}
      </FlexItem>
    </Flex>
  );
};
